<template>
  <div class="access">
    <h2 class="title-bunner-container">
      <img class="title-bunner" src="../assets/bunner/access.png" alt="交通案内">
    </h2>
    <div class="container text-left pl-1">
      <div class="row print-button-container">
        <button class="col-sm-2 print-buttton pl-2 pr-2" @click="print">印刷する</button>
      </div>
      <div class="row mt-5 text-center justify-content-center align-items-center map-row">
        <div class="col-md-6 col-lg-5 mb-3">
          <img class="map-overview" src="../assets/katsuura_map_overview.png" alt="交通概念図">
        </div>
        <div class="col-md-6 col-lg-5 mb-3">
          <map-view class="map-container" :center="{lat:33.9351956,lng:134.5081886}" :zoom="13.21"/>
        </div>
      </div>
      <div class="row">
        <div class="col-12 access-title-container">
          <h5>飛行機をご利用の場合</h5>
        </div>
        <p class="col-12 pt-2 access-text">
          徳島阿波おどり空港に到着後、リムジンバスにて徳島駅へ。所要時間は約30分。
          <br>その後、徳島バス勝浦線をご利用ください。空港からレンタカーの利用も可能です。
        </p>
      </div>
      <div class="row">
        <div class="col-12 access-title-container">
          <h5>バスをご利用の場合</h5>
        </div>
        <p class="col-12 pt-2 access-text">
          徳島バス勝浦線にご乗車ください。
          <br>所要時間は、徳島駅より約60分、小松島市からは約30分です。
        </p>
      </div>
      <div class="row">
        <div class="col-12 access-title-container">
          <h5>マイカーでお越しの場合</h5>
        </div>
        <p class="col-12 pt-2 access-text">
          徳島市から国道55号線を南下し、勝浦川橋南詰交差点を右折し、県道16号線を進んでください。
          <br>所要時間は、鳴門市から約60分、徳島市から約30分です。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import WpClient from "../wpClient.js";
import MapView from "@/components/MapView";

export default {
  name: "Access",
  components: {
    MapView
  },
  props: {
    slug: String
  },
  async mounted() {
    this.data = (await WpClient.getCalendarPost(this.slug))[0];
  },
  methods: {
    print() {
      window.print();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.print-button-container {
  border-top: rgb(238, 238, 238) 3px solid;
  border-bottom: rgb(238, 238, 238) 3px solid;
}

.print-buttton {
  background-color: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  padding: 0;
  appearance: none;
  display: flex;
  margin: 0;
  justify-content: center;
  align-items: center;
  height: 3rem;
  width: 100%;
}

.print-buttton:hover {
  opacity: 0.4;
  background-color: rgb(238, 238, 238);
}

.access-title-container {
  border-top: black 1px solid;
  border-bottom: black 1px solid;
  margin-top: 1rem;
  padding-top: 0.3rem;
  @media print {
    margin-top: 0.1rem;
    h5 {
      font-size: 18px;
    }
  }
}
.access-text {
  @media print {
    font-size: 12px;
  }
}

.map-overview-container {
}
.map-overview {
  max-width: 100%;
}

@media print {
  .map-row {
    height: 500px;
    & > div {
      width: 50%;
      .img-fluid {
        object-fit: contain;
        height: 300px;
        width: 300px;
        // height: 480px;
      }
    }
  }
}
</style>

<style lang="scss">
.access {
  .map-container {
    .map,
    .map-view {
      @media (min-width: 576px) {
        // width: 450px;
      }
      /* // 中デバイス（タブレット, 768px 以上） */
      @media (min-width: 768px) {
        height: 300px;
      }

      /* // 大デバイス（デスクトップ, 992px 以上） */
      @media (min-width: 992px) {
        height: 350px;
      }

      /* // 特大デバイス（ワイド・デスクトップ, 1200px 以上） */
      @media (min-width: 1200px) {
        height: 400px;
      }
    }
  }
}
</style>

